import * as R from 'ramda'
import * as recompose from 'recompose'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as jurisdiction from '@rushplay/compliance/jurisdiction'
import { withTranslate } from '@rushplay/i18n'

import * as configuration from '../configuration'
import { NotFound } from '../components/not-found'
import { getTranslationKey } from '../utils/brand-translation-prefix'

import { StaticPage as Component } from './static-page'

function mapStateToProps(state, props) {
  const pageKey = props.match.params[0]
  const brand = configuration.getBrand(state.configuration)
  const contentKey = getTranslationKey(brand, `${pageKey}.content`)

  return {
    licenseId: jurisdiction.getLicense(state.jurisdiction),
    location: props.location,
    title: props.translate(`${pageKey}.title`),
    content: props.translate(contentKey),
    pageKey,
  }
}

const connector = R.compose(
  recompose.setPropTypes({
    translate: PropTypes.func.isRequired,
  }),
  withTranslate,
  connect(mapStateToProps),
  recompose.branch(
    props =>
      R.equals(props.licenseId, 'curacao') &&
      R.equals(props.pageKey, 'cookie-policy'),
    recompose.renderComponent(NotFound)
  )
)

export const StaticPage = connector(Component)
